import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import * as _ from 'lodash';
import * as moment from 'moment';
import { RecommendedPartsPluginService } from './recommendedparts-plugin.service';
import { CurrencyService } from '../../shared/services/currency.service';

@Component({
    templateUrl: './recommendedparts-edit.component.html',
    standalone: false
})
export class RecommendedPartsEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  public plugin: any;
  editForm: UntypedFormGroup;
  public processing = false;

  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  // @ViewChild('CurrencyModal') CurrencyModal: ModalComponent;
  public currencies: any[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: RecommendedPartsPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private currencyService: CurrencyService
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateRecommendedParts(this.inspectionId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.currencyService.getCurrencies().subscribe((currencies) => (this.currencies = currencies));
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      CriticalParts: new UntypedFormControl(this.plugin.config.CriticalParts, Validators.min(0)),
      DamagedParts: new UntypedFormControl(this.plugin.config.DamagedParts, Validators.min(0)),
      WornParts: new UntypedFormControl(this.plugin.config.WornParts, Validators.min(0)),
      OtherParts: new UntypedFormControl(this.plugin.config.OtherParts, Validators.min(0)),
      Currency: new UntypedFormControl(this.plugin.config.Currency, Validators.required)
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, null, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
